import React, { useEffect, useRef, useState } from 'react';
import { cx } from '../../utils/cx.js';

/**
 * Insights "i" badge with a tooltip. Hover on desktop, tap on touch; closes on outside
 * click or Escape. Typography is reset so it can live inside uppercase or bold headers.
 */
const InfoTip = ({ text, className = '', width = 'w-56', align = 'right' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!text) return null;

  return (
    <span
      ref={ref}
      className={cx('relative inline-flex', className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="Plus d'informations"
        aria-expanded={open}
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        className="inline-flex h-3.5 w-3.5 cursor-help items-center justify-center rounded-full border border-gray-300 text-[9px] font-bold leading-none text-gray-400 outline-none transition-colors hover:border-gray-400 hover:text-gray-600 focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-600 dark:hover:text-gray-300"
      >
        i
      </button>
      {open && (
        <span
          role="tooltip"
          className={cx(
            'absolute top-full z-50 mt-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[11px] font-normal normal-case leading-snug tracking-normal text-gray-600 shadow-xl dark:border-gray-700 dark:bg-night-750 dark:text-gray-300',
            align === 'right' ? 'right-0' : 'left-0',
            width,
          )}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTip;
